export default __webpack_public_path__ + "static/media/II - 2024.fed267a8.pdf";